module.exports = "<button type=\"submit\" (click)=\"performAction('approved')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'APPROVE' | translate }}</span></button>\n<span class=\"space-xs\"></span>\n<button type=\"submit\" (click)=\"performAction('rejected')\"  md-raised-button class=\"btn-w-sm btn-w-md btn-red font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'REJECT' | translate }}</span></button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/approve-reject-request/approve-reject.component.html
// module id = 1248
// module chunks = 10